<template>
  <tr
    v-if="bluredOrNotHidden"
    :class="{ active: isActive, hovered: showActions }"
  >
    <DefineTemplate v-slot="{ item, index }">
      <table
        width="100%"
        style="border-spacing: 0px"
        :style="
          block.children[0].attributes['inner-attributes']
            ? getTabelStyle(block.children[0])
            : {}
        "
      >
        <tbody>
          <MjApiBlock
            v-for="(pblock, indexL) in layout"
            :key="indexL"
            :item="item"
            :index="index"
            :block="pblock"
            :product="block"
            :section-index="sectionIndex"
            :column-index="columnIndex"
            :block-index="blockIndex"
            @open-settings="productClicked"
          ></MjApiBlock>
        </tbody>
      </table>
    </DefineTemplate>
    <td
      :class="{
        'block-borders': showDragBorder,
        'dragged-opacity': isCurrentElementDragged,
      }"
      class="draggableBlock"
      data-block="Product"
      @mouseover="mouseOver"
      @mouseleave="mouseOut"
      @click.stop="() => click()"
    >
      <blockActions
        v-if="showActions && !prodstructure"
        :column-padding-x="columnPaddingX"
        :column-width="columnWidth"
        :disable-up-movement="disableUpMovement"
        :disable-down-movement="disableDownMovement"
        :block-height="blockHeight"
        :block-width="blockWidth"
        :is-active="isActive"
        :is-last-column="isLastColumn"
        :section-index="sectionIndex"
        :column-index="columnIndex"
        :block-index="blockIndex"
        :product="true"
        :click="click"
        :show-paste="showPaste"
        :copied="copied"
        @duplicate="copyBlock"
        @remove="deleteBlock"
        @moveUp="moveUp"
        @moveDown="moveDown"
        @copy="copyToClipboard"
      ></blockActions>
      <div
        v-if="items.length < 1 || (mode === 'dynamic' && !forMergetag)"
        class="relative grid w-full cursor-pointer justify-center bg-[#e7f3ff] py-5 text-center font-inter leading-[18px] text-[#6da8ff] outline outline-[#6da8ff4d] hover:bg-[#cee7ff] hover:text-[#4883ff]"
        style="font-size: 13px"
        data-testid="empty-state"
      >
        <div class="pointer-events-none m-auto">
          <div>
            <svg
              id="Layer_2"
              width="60"
              data-name="Layer 2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 90.91 101.36"
              class="inline"
            >
              <g id="Icons">
                <g>
                  <path
                    class="cls-1"
                    d="M90.86,28.28L77.41,0H13.51L.06,28.28H.06l-.06,73.08h90.91l-.06-73.08h0ZM87.02,28.28h-39.81V3.5h27.85l11.96,24.78ZM15.86,3.5h27.85v24.78H3.89L15.86,3.5ZM87.41,97.86H3.5V31.78h83.91v66.08Z"
                    fill="currentColor"
                  />
                  <path
                    class="cls-1"
                    d="M32.74,52.22h25.43c3.3,0,5.99-2.69,5.99-5.99s-2.69-5.99-5.99-5.99h-25.43c-3.3,0-5.99,2.69-5.99,5.99s2.69,5.99,5.99,5.99ZM32.74,43.74h25.43c1.37,0,2.49,1.12,2.49,2.49s-1.12,2.49-2.49,2.49h-25.43c-1.37,0-2.49-1.12-2.49-2.49s1.12-2.49,2.49-2.49Z"
                    fill="currentColor"
                  />
                </g>
              </g>
            </svg>
            <div class="mt-2">
              {{
                supportsDynamicBlocks && mergetags.length > 0
                  ? $t("api_block.empty_state")
                  : ""
              }}
            </div>
          </div>
        </div>
      </div>
      <div v-else :id="id" :style="hiddenStyle">
        <table
          v-if="itemsLayout === 'column'"
          :id="id"
          width="100%"
          style="border-spacing: 0px"
        >
          <tr>
            <td
              style="
                text-align: center;
                vertical-align: top;
                direction: ltr;
                font-size: 0px;
              "
            >
              <template v-if="mode === 'dynamic'">
                <div
                  v-for="index in maxPerRow"
                  :key="index"
                  data-testid="loop-column"
                  style="
                    display: inline-block;
                    direction: ltr;
                    font-size: 13px;
                    text-align: left;
                    box-sizing: border-box;
                  "
                  :style="{
                    ...getColumnStyle(block.children[0]),
                    width: `${getColumnWidth(100 / maxPerRow + '%')}`,
                  }"
                >
                  <ReuseTemplate :item="items[0]" :index="index" />
                </div>
              </template>
              <template v-else>
                <div
                  v-for="(item, index) in items"
                  :key="item.id + '-' + index"
                  data-testid="loop-column"
                  style="
                    display: inline-block;
                    direction: ltr;
                    font-size: 13px;
                    text-align: left;
                    box-sizing: border-box;
                  "
                  :style="{
                    ...getColumnStyle(block.children[0]),
                    width: `${getColumnWidth(100 / Math.min(maxPerRow, items.length) + '%')}`,
                  }"
                >
                  <ReuseTemplate :item="item" :index="index" />
                </div>
                <template
                  v-if="
                    doNotStackOnMobile &&
                    items.length % maxPerRow !== 0 &&
                    items.length > maxPerRow
                  "
                >
                  <div
                    v-for="i in maxPerRow - (items.length % maxPerRow)"
                    :key="'empty' + i"
                    data-testid="loop-column"
                    style="
                      display: inline-block;
                      direction: ltr;
                      font-size: 13px;
                      text-align: left;
                      box-sizing: border-box;
                    "
                    :style="{
                      ...getColumnStyle(block.children[0]),
                      width: `${100 / maxPerRow}% !important`,
                    }"
                  ></div>
                </template>
              </template>
            </td>
          </tr>
        </table>
        <div v-else>
          <div
            v-for="(item, index) in items"
            :id="id"
            :key="item.id + '-' + index"
            :style="getColumnStyle(block.children[0])"
            style="width: auto"
          >
            <table
              width="100%"
              style="border-spacing: 0px"
              :style="
                block.children[0].attributes['inner-attributes']
                  ? getTabelStyle(block.children[0])
                  : {}
              "
            >
              <tr>
                <td
                  :style="{
                    direction: itemsLayout === 'text-image' ? 'rtl' : 'ltr',
                  }"
                >
                  <div
                    data-testid="product-column"
                    style="display: inline-block"
                    :style="{ verticalAlign: valign, width: subColumnWidth }"
                  >
                    <table width="100%" style="border-spacing: 0px">
                      <MjApiBlock
                        :key="`image-${layout.indexOf('image')}`"
                        :block="layout[layout.indexOf('image')]"
                        :item="item"
                        :index="index"
                        :product="block"
                        :section-index="sectionIndex"
                        :column-index="columnIndex"
                        :block-index="blockIndex"
                        @open-settings="productClicked"
                      ></MjApiBlock>
                    </table>
                  </div>
                  <div
                    data-testid="product-column"
                    style="display: inline-block"
                    :style="{
                      verticalAlign: valign,
                      width: subColumnWidth,
                      direction: 'ltr',
                    }"
                  >
                    <table width="100%" style="border-spacing: 0px">
                      <MjApiBlock
                        v-for="(pblock, indexL) in layoutWithoutImage"
                        :key="indexL"
                        :block="pblock"
                        :item="item"
                        :index="index"
                        :product="block"
                        :section-index="sectionIndex"
                        :column-index="columnIndex"
                        :block-index="blockIndex"
                        @open-settings="productClicked"
                      ></MjApiBlock>
                    </table>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script lang="ts" setup>
  import blockProperties from "@/composables/useBlockProperties";
  import blockActions from "./blockActions.vue";
  import MjApiBlock from "./apiBlock/mjApiBlock.vue";
  import { TopolFeedBlock } from "@/schemas/template/blocks/feedBlockSchema";
  import { TopolLoopBlock } from "@/schemas/template/blocks/loopBlockSchema";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useApiBlocksStore } from "@/stores/apiBlocks";
  import { computed, onMounted } from "vue";
  import { createReusableTemplate } from "@vueuse/core";

  const [DefineTemplate, ReuseTemplate] = createReusableTemplate();

  const props = defineProps<{
    block: TopolFeedBlock;
    columnIndex: number;
    sectionIndex: number;
    blockIndex: number;
    isLocked: boolean;
  }>();

  const {
    bluredOrNotHidden,
    showActions,
    showPaste,
    blockHeight,
    blockWidth,
    hiddenStyle,
    id,
    isActive,
    disableUpMovement,
    disableDownMovement,
    columnPaddingX,
    columnWidth,
    isCurrentElementDragged,
    showDragBorder,
    isLastColumn,
    copied,
    mouseOver,
    mouseOut,
    click,
    copyBlock,
    deleteBlock,
    moveUp,
    moveDown,
    copyToClipboard,
  } = blockProperties(props);

  const mjmlStore = useMjmlStore();
  const apiBlocksStore = useApiBlocksStore();

  const columnPotentialInnerAttributes = [
    "border-radius",
    "border",
    "background-color",
    "border-top",
    "border-bottom",
    "border-left",
    "border-right",
    "column-gradient",
  ];

  const items = computed<any[]>(() => {
    return mjmlStore.getActiveBlockFeedItems(props.block) || [];
  });

  const itemsLayout = computed(() => {
    return props.block.layout;
  });

  const maxPerRow = computed(() => {
    return props.block.maxPerRow || 3;
  });

  const mode = computed(() => {
    if (props.block["mode"]) {
      return props.block["mode"];
    }
    return "static";
  });

  const forMergetag = computed(() => {
    if (props.block.forMergeTag) {
      return props.block.forMergeTag;
    }
    return null;
  });

  const layout = computed(() => {
    const blocks = props.block.attributes["layout"].split(",");
    const layout = [];
    for (const i in blocks) {
      const blockParts = blocks[i].split(":");
      if (blockParts[1] == "show") {
        layout.push(blockParts[0]);
      }
    }
    return layout;
  });

  const layoutWithoutImage = computed(() => {
    const blocks = props.block.attributes["layout"].split(",");
    const layout = [];
    for (const i in blocks) {
      const blockParts = blocks[i].split(":");
      if (blockParts[1] == "show" && blockParts[0] !== "image") {
        layout.push(blockParts[0]);
      }
    }
    return layout;
  });

  const subColumnWidth = computed(() => {
    if (mjmlStore.isMobileFirstEnabled) {
      if (mjmlStore.isMobileView && !doNotStackOnMobile.value) {
        return "100%";
      }
    }

    return "50%";
  });

  const valign = computed(() => {
    if (props.block.attributes["vertical-align"]) {
      return props.block.attributes["vertical-align"];
    } else {
      return "middle";
    }
  });

  const prodstructure = computed(() => {
    if (props.block.attributes["prodstructure"]) {
      return props.block.attributes["prodstructure"];
    }
    return false;
  });

  const supportsDynamicBlocks = computed(() => {
    return apiBlocksStore.supportsDynamicBlocks;
  });

  const mergetags = computed(() => {
    return (
      apiBlocksStore.blocks.get(props.block.blockName)?.dynamicMergetags || []
    );
  });

  const doNotStackOnMobile = computed(() => {
    return props.block.attributes["in-group"];
  });

  function getColumnWidth(width: string) {
    if (mjmlStore.isMobileFirstEnabled) {
      if (mjmlStore.isMobileView && !doNotStackOnMobile.value) {
        return "100%";
      }
    }

    return width || "100%";
  }

  function getTabelStyle(column: TopolLoopBlock["children"][0]) {
    const style: any = {};
    for (const attr in column.attributes) {
      if (columnPotentialInnerAttributes.includes(attr)) {
        if (attr === "column-gradient") {
          style["background-image"] =
            column.attributes[attr as keyof typeof column.attributes];
          continue;
        }
        style[attr] = column.attributes[attr as keyof typeof column.attributes];
      }
    }
    return style;
  }

  function getColumnStyle(column: TopolLoopBlock["children"][0]) {
    const style: any = {};
    if (column.attributes["inner-attributes"]) {
      for (const attr in column.attributes) {
        if (
          !columnPotentialInnerAttributes.includes(attr) &&
          attr !== "css-class" &&
          attr !== "inner-attributes"
        ) {
          style[attr] =
            column.attributes[attr as keyof typeof column.attributes];
        }
      }
    } else {
      for (const attr in column.attributes) {
        if (attr !== "css-class" && attr !== "inner-attributes") {
          if (attr === "column-gradient") {
            style["background-image"] =
              column.attributes[attr as keyof typeof column.attributes];
            continue;
          }
          style[attr] =
            column.attributes[attr as keyof typeof column.attributes];
        }
      }
    }
    return style;
  }

  function productClicked(type: string) {
    click(type);
  }

  onMounted(() => {
    if (!supportsDynamicBlocks.value && mode.value === "dynamic") {
      mjmlStore.updateSpecificBlockProp({
        sectionIndex: props.sectionIndex,
        columnIndex: props.columnIndex,
        blockIndex: props.blockIndex,
        prop: "mode",
        value: "static",
      });
      mjmlStore.updateSpecificBlockProp({
        sectionIndex: props.sectionIndex,
        columnIndex: props.columnIndex,
        blockIndex: props.blockIndex,
        prop: "items",
        value: [],
      });
    }
  });
</script>
